export const LAST_MESSAGE_DATE_KEY = 'lastMessageDate'
export const LAST_MESSAGE_AUTHOR_KEY = 'lastMessageAuthor'
export const DUE_DATE_FILTER_KEY = 'dueDate'
